import React from 'react';

import { Box, Typography } from '@mui/material';

import { CARD_SX } from './constants';

interface StatCardProps {
  label: string;
  value: string;
  subtitle: string;
  valueColor?: string;
  fontSize?: number;
}

export default function StatCard({ label, value, subtitle, valueColor, fontSize = 32 }: StatCardProps) {
  return (
    <Box sx={CARD_SX}>
      <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1, fontWeight: 500 }}>{label}</Typography>
      <Typography sx={{ fontSize, fontWeight: 700, mb: 0.5, color: valueColor }}>{value}</Typography>
      <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>{subtitle}</Typography>
    </Box>
  );
}
